export const getCanonicalUrl = (path: string = ''): string => {
  const hostname = window.location.hostname;
  const baseUrl = hostname.includes('fr.diskover.ovh') 
    ? 'https://fr.diskover.ovh' 
    : 'https://diskover.ovh';
  return `${baseUrl}${path}`;
};

export const getAlternateUrls = (path: string = '') => {
  return {
    fr: `https://fr.diskover.ovh${path}`,
    en: `https://diskover.ovh${path}`
  };
};

export const addHreflangLinks = (path: string = '') => {
  // Remove existing hreflang links
  const existingLinks = document.querySelectorAll('link[hreflang]');
  existingLinks.forEach(link => link.remove());

  const alternateUrls = getAlternateUrls(path);
  
  // Add hreflang links
  const frLink = document.createElement('link');
  frLink.rel = 'alternate';
  frLink.hreflang = 'fr';
  frLink.href = alternateUrls.fr;
  document.head.appendChild(frLink);

  const enLink = document.createElement('link');
  enLink.rel = 'alternate';
  enLink.hreflang = 'en';
  enLink.href = alternateUrls.en;
  document.head.appendChild(enLink);

  // Add x-default for French (main domain)
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'alternate';
  defaultLink.hreflang = 'x-default';
  defaultLink.href = alternateUrls.fr;
  document.head.appendChild(defaultLink);
};

// Function to create clean URL slugs and handle encoding variants
export const sanitizePlaceName = (name: string): string => {
  return name
    .trim()
    .replace(/\s+/g, ' ') // Normalize spaces
    .replace(/['']/g, "'") // Normalize apostrophes
    .replace(/[""]/g, '"') // Normalize quotes
    .replace(/–/g, '-') // Normalize dashes
    .replace(/…/g, '...'); // Normalize ellipsis
};